import { Injectable, EventEmitter } from '@angular/core';
import { get, isEqual } from 'lodash';
import { UserService } from './user.service';
import { ADMIN_ROLE } from '../_constants/authConstants';
import { Router } from '@angular/router';
import { clearLocalStorageExceptCharts } from '../_helpers/window.helper';

@Injectable({
    providedIn: 'root',
})
export class DataShareService {
    isMenuListSuccess: Boolean = false;
    userPolicyList = [];
    public policyChange: EventEmitter<any> = new EventEmitter<any>();

    constructor(private userService: UserService, private router: Router) {
        //    this.getPolicyList();
    }
    async getPolicyList() {
        return new Promise(async (resolve, reject) => {
            try {
                if (!this.isMenuListSuccess) {
                    var StorageData = localStorage.getItem('currentUser');
                    const currentUserData = StorageData ? JSON.parse(StorageData) : null;
                    if (currentUserData && get(currentUserData.user, 'userId')) {
                        let userPolicyList: any = await this.userService.getMenuList(currentUserData.user.userId);
                        var StorageData = localStorage.getItem('userPolicyList');
                        if (StorageData !== null) {
                            const userOldPolicyList = JSON.parse(StorageData ? StorageData : "");
                            if (isEqual(userPolicyList, userOldPolicyList)) {
                                const roleName = get(currentUserData.user.userRoles[0].role, 'roleName', '');
                                if (roleName != ADMIN_ROLE) {
                                    let index = userPolicyList.findIndex((x: any) => x.moduleName === "UserSettings");
                                    if (index > -1) {
                                        userPolicyList.splice(index, 1);
                                    }
                                }
                                this.userPolicyList = userPolicyList;
                                this.isMenuListSuccess = true;
                                resolve(userPolicyList);
                            } else {
                                clearLocalStorageExceptCharts();
                                reject('Policy Changed');
                                console.log('Policy Changed');
                                window.location.href = "/";
                            }
                        }
                        else {
                            reject('USER ID Not FOUND');
                            this.router.navigate(['/auth/login']);
                        }
                    }
                } else {
                    resolve(this.userPolicyList);
                    localStorage.setItem('userPolicyList1', JSON.stringify(this.userPolicyList))
                }
            } catch (err) {
                this.router.navigate(['/auth/login']);
                console.log(err);
                reject(err);
            }
        });
    }
    public policyListUpdate(message: any) {
        this.policyChange.emit({ message: message });
    }
}
